import React from "react";
import RadioButton from  "./RadioButton";
import "./radio-button-list.css";

class RadioButtonList extends React.Component{
  constructor (props){
    super(props);
  }

  render(){
    return (
      <div className="list-radio">
        <div className="pure-u-8-24">
          <RadioButton classes="radio-visualizar" onClick={this.props.onClick} title={this.props.title} value="1" name={this.props.name}></RadioButton>
        </div>
        {
          /*
          <div className="list-radio__title">{this.props.title}</div>
          <div className="pure-u-8-24">
            <RadioButton classes="radio-visualizar" onClick={this.props.onClick} title="Visualizar" value="1" name={this.props.name}></RadioButton>
          </div>
          <div className="pure-u-8-24">
            <RadioButton classes="radio-editar" onClick={this.props.onClick} title="Criar/Editar" value="2" name={this.props.name}></RadioButton>
          </div>
          <div className="pure-u-8-24">
            <RadioButton classes="radio-deletar" onClick={this.props.onClick} title="Remover" value="3" name={this.props.name}></RadioButton>
          </div>
          */
        }
      </div>
    )
  }
}

export default RadioButtonList;



// WEBPACK FOOTER //
// ./src/components/form/RadioButtonList.js